import './banner.scss';

export default () => {
	$( '.js-scroll' ).click( function ( e ) {
		e.preventDefault();
		let target =  $( this ).closest( '.banner' ).next();

		if ( target.length ) {
			let scrollTo = target.offset().top - 40;

			$( 'body, html' ).animate( {
				scrollTop: `${scrollTo}px`,
			}, 1000 );
		}
	} );
};
